module.exports = __webpack_public_path__ + "static/media/certificateRequest.d8978565.svg";